// extracted by mini-css-extract-plugin
export default {"foregroundContainer":"App_foregroundContainer__tRMSC","heading":"App_heading__tOEFd"};